import { render, staticRenderFns } from "./kjn.vue?vue&type=template&id=a3296ffa"
import script from "./kjn.vue?vue&type=script&lang=js"
export * from "./kjn.vue?vue&type=script&lang=js"
import style0 from "./kjn.vue?vue&type=style&index=0&id=a3296ffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports